import React from "react";

const requiredField = (value) => {
  if (!value) {
    return <div role="alert">This field is required</div>;
  }
};

export default requiredField;
